<template>
  <section id="your-country" aria-labelledby="country-heading" class="py-20 px-6 bg-gray-50" data-testid="country-highlights">
    <div class="max-w-[1300px] mx-auto">
      <header class="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
        <div class="max-w-3xl">
          <span class="inline-flex items-center gap-2 bg-blue-100 text-[#1E3A5F] text-xs font-semibold px-3 py-1.5 rounded-full mb-4">
            <span aria-hidden="true">{{ flag }}</span>
            {{ pitch.eyebrow }}
          </span>
          <h2 id="country-heading" class="text-3xl md:text-4xl font-bold text-gray-900 leading-tight" data-testid="country-heading">
            {{ pitch.heading }}
          </h2>
          <p class="mt-4 text-lg text-gray-600">{{ pitch.intro }}</p>
        </div>
        <div v-if="!isWhiteLabel" class="flex flex-col gap-2 shrink-0">
          <span class="text-xs font-medium text-gray-500">Not where you are?</span>
          <CountryPicker />
        </div>
      </header>

      <ul class="grid md:grid-cols-2 gap-6 list-none m-0 p-0" :class="pitch.highlights.length === 3 ? 'lg:grid-cols-3' : 'lg:grid-cols-4'">
        <li
          v-for="item in pitch.highlights"
          :key="item.title"
          class="bg-white border border-gray-200 rounded-2xl p-6"
          data-testid="country-highlight"
        >
          <div class="mb-4 text-[#1A56DB]" aria-hidden="true">
            <i :class="['text-2xl', item.icon]"></i>
          </div>
          <h3 class="font-bold text-gray-900 mb-2">{{ item.title }}</h3>
          <p class="text-sm text-gray-600 leading-relaxed m-0">{{ item.description }}</p>
        </li>
      </ul>

      <div v-if="!isWhiteLabel" class="mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 bg-white border border-blue-200 rounded-2xl p-6">
        <p class="text-gray-700 m-0" data-testid="country-gateway-ask">
          {{ pitch.gatewayAsk ?? 'Prices on this site are shown in your currency. Ask us for a proposal tailored to your institution.' }}
        </p>
        <Button
          :label="pitch.ctaLabel"
          icon="pi pi-arrow-right"
          icon-pos="right"
          class="!bg-[#1A56DB] !border-[#1A56DB] whitespace-nowrap"
          data-testid="country-demo-cta"
          @click="store.openDemo()"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import CountryPicker from '@/components/landing/CountryPicker.vue';
import { useBranding } from '@/composables/useBranding';
import { useLandingCountry } from '@/composables/landing/useLandingCountry';
import { useLandingStore } from '@/store/landingStore';
import { countryFlag } from '@/utils/landing/countryProfiles';
import { countryPitch } from '@/utils/landing/countryHighlights';

const { isWhiteLabel } = useBranding();
const store = useLandingStore();
const { profile, isProfiled, countryCode } = useLandingCountry();

const pitch = computed(() => countryPitch(profile.value, isProfiled.value));
const flag = computed(() => (countryCode.value ? countryFlag(countryCode.value) : '🌍'));
</script>
